import { BaseDto } from './base.dto';
export class ConfigurationDataTypeDto extends BaseDto{

    name: string;
    metadata?: string;
}